import React from "react";
import { array, object, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import { toBanglaNum } from "../../utils/utils";

import "./imageNumber.m.css";

const ImageNumber = ({ element, imageElements, lang }) => {
  const checkingImageNumber = (id) => {
    const imageNumber = imageElements.findIndex((item) => item.id === id);
    return imageNumber + 1;
  };
  return (
    <React.Fragment>
      <div styleName="wrapper">
        {`${lang === "en" ? checkingImageNumber(element.id) : toBanglaNum(checkingImageNumber(element.id))} / ${
          lang === "en" ? imageElements.length : toBanglaNum(imageElements.length)
        }`}
      </div>
    </React.Fragment>
  );
};

ImageNumber.propTypes = {
  element: object,
  imageElements: array,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(ImageNumber);
